export const INPUT_10_CHARS_3_SYMBOLS_AFTER_DECIMAL_POINT = /^\d{1,10}$|(?=^.{1,10}$)^\d+\.\d{0,3}$/gm;
export const INPUT_10_CHARS_2_SYMBOLS_AFTER_DECIMAL_POINT = /^\d{1,10}$|(?=^.{1,10}$)^\d+\.\d{0,2}$/gm;
export const INPUT_5_CHARS_3_SYMBOLS_AFTER_DECIMAL_POINT = /^\d{1,5}$|(?=^.{1,5}$)^\d+\.\d{0,3}$/gm;
export const INPUT_5_CHARS_1_SYMBOLS_AFTER_DECIMAL_POINT = /^\d{1,5}$|(?=^.{1,5}$)^\d+\.\d{0,1}$/gm;
export const INPUT_EXCLUDE_SYMBOLS = /[^\d.]+/g;
export const INTEGER = /^-?\d+$/g;
